import sfxDialogAcceptCorrectiveWork from "./sfxDialogAcceptCorrectiveWork"
import sfxDialogAcceptWork from "./sfxDialogAcceptWork"
import sfxDialogAddAttachments from "./sfxDialogAddAttachments"
import sfxDialogAddComment from "./sfxDialogAddComment"
import sfxDialogAttachmentDetails from "./sfxDialogAttachmentDetails"
import sfxDialogAuthentication from "./sfxDialogAuthentication"
import sfxDialogChangePassword from "./sfxDialogChangePassword"
import sfxDialogChangeRequest from "./sfxDialogChangeRequest"
import sfxDialogChangeUnlockKey from "./sfxDialogChangeUnlockKey"
import sfxDialogCloseIssueCorrected from "./sfxDialogCloseIssueCorrected"
import sfxDialogCloseIssueNotCorrected from "./sfxDialogCloseIssueNotCorrected"
import sfxDialogCloseWorkOrderCompleted from "./sfxDialogCloseWorkOrderCompleted"
import sfxDialogCloseWorkOrderNotCompleted from "./sfxDialogCloseWorkOrderNotCompleted"
import sfxDialogConnectVueDevtools from "./sfxDialogConnectVueDevtools"
import sfxDialogDataFetch from "./sfxDialogDataFetch"
import sfxDialogDevicePermission from "./sfxDialogDevicePermission"
import sfxDialogDiscardWork from "./sfxDialogDiscardWork"
import sfxDialogEasterEgg from "./sfxDialogEasterEgg"
import sfxDialogEditCorrectionInfo from "./sfxDialogEditCorrectionInfo"
import sfxDialogFeedback from "./sfxDialogFeedback"
import sfxDialogFilter from "./sfxDialogFilter"
import sfxDialogHelp from "./sfxDialogHelp"
import sfxDialogHttp from "./sfxDialogHttp"
import sfxDialogIdentifier from "./sfxDialogIdentifier"
import sfxDialogImageDelete from "./sfxDialogImageDelete"
import sfxDialogItemClone from "./sfxDialogItemClone"
import sfxDialogListAttachmentDelete from "./sfxDialogListAttachmentDelete"
import sfxDialogListIdentifier from "./sfxDialogListIdentifier"
import sfxDialogListIssue from "./sfxDialogListIssue"
import sfxDialogListUnsubmittedWork from "./sfxDialogListUnsubmittedWork"
import sfxDialogListWorkOrder from "./sfxDialogListWorkOrder"
import sfxDialogListWorkOrderSelect from "./sfxDialogListWorkOrderSelect"
import sfxDialogOffline from "./sfxDialogOffline"
import sfxDialogProofOfPresence from "./sfxDialogProofOfPresence"
import sfxDialogRejectCorrectiveWork from "./sfxDialogRejectCorrectiveWork"
import sfxDialogRejectedCorrectiveWork from "./sfxDialogRejectedCorrectiveWork"
import sfxDialogRejectIssue from "./sfxDialogRejectIssue"
import sfxDialogRejectWork from "./sfxDialogRejectWork"
import sfxDialogRelatedUnsubmittedWork from "./sfxDialogRelatedUnsubmittedWork"
import sfxDialogRemoveEntityFromWorkOrder from "./sfxDialogRemoveEntityFromWorkOrder"
import sfxDialogSelectModel from "./sfxDialogSelectModel"
import sfxDialogStagnantWork from "./sfxDialogStagnantWork"
import sfxDialogSupersedeIssue from "./sfxDialogSupersedeIssue"
import sfxDialogSystem from "./sfxDialogSystem"
import sfxDialogTableConfigurations from "./sfxDialogTableConfigurations"
import sfxDialogToDo from "./sfxDialogToDo"
import sfxDialogUnsavedChanges from "./sfxDialogUnsavedChanges"
import sfxDialogUnsavedWorkOrderDraft from "./sfxDialogUnsavedWorkOrderDraft"
import sfxDialogUnsubmittedIssues from "./sfxDialogUnsubmittedIssues"
import sfxDialogUserSettings from "./sfxDialogUserSettings"
import sfxDialogWarning from "./sfxDialogWarning"
import sfxDialogWorkMustBeReviewed from "./sfxDialogWorkMustBeReviewed"
import sfxDialogWorkOrderEntities from "./sfxDialogWorkOrderEntities"
import sfxDialogWorkOrderRemoveEntity from "./sfxDialogWorkOrderRemoveEntity"
import sfxDialogWrongIdentifier from "./sfxDialogWrongIdentifier"

export default {
  sfxDialogAcceptCorrectiveWork,
  sfxDialogAcceptWork,
  sfxDialogAddAttachments,
  sfxDialogAddComment,
  sfxDialogAttachmentDetails,
  sfxDialogAuthentication,
  sfxDialogChangePassword,
  sfxDialogChangeRequest,
  sfxDialogChangeUnlockKey,
  sfxDialogCloseIssueCorrected,
  sfxDialogCloseIssueNotCorrected,
  sfxDialogCloseWorkOrderCompleted,
  sfxDialogCloseWorkOrderNotCompleted,
  sfxDialogConnectVueDevtools,
  sfxDialogDataFetch,
  sfxDialogDevicePermission,
  sfxDialogDiscardWork,
  sfxDialogEasterEgg,
  sfxDialogEditCorrectionInfo,
  sfxDialogFeedback,
  sfxDialogFilter,
  sfxDialogHelp,
  sfxDialogHttp,
  sfxDialogIdentifier,
  sfxDialogImageDelete,
  sfxDialogItemClone,
  sfxDialogListAttachmentDelete,
  sfxDialogListIdentifier,
  sfxDialogListIssue,
  sfxDialogListUnsubmittedWork,
  sfxDialogListWorkOrder,
  sfxDialogListWorkOrderSelect,
  sfxDialogOffline,
  sfxDialogProofOfPresence,
  sfxDialogRejectCorrectiveWork,
  sfxDialogRejectedCorrectiveWork,
  sfxDialogRejectIssue,
  sfxDialogRejectWork,
  sfxDialogRelatedUnsubmittedWork,
  sfxDialogRemoveEntityFromWorkOrder,
  sfxDialogSelectModel,
  sfxDialogStagnantWork,
  sfxDialogSupersedeIssue,
  sfxDialogSystem,
  sfxDialogTableConfigurations,
  sfxDialogToDo,
  sfxDialogUnsavedChanges,
  sfxDialogUnsavedWorkOrderDraft,
  sfxDialogUnsubmittedIssues,
  sfxDialogUserSettings,
  sfxDialogWarning,
  sfxDialogWorkMustBeReviewed,
  sfxDialogWorkOrderEntities,
  sfxDialogWorkOrderRemoveEntity,
  sfxDialogWrongIdentifier,
}
